import SegmentWrapper from 'lib/segment';

export default store =>
  next => action => {
    SegmentWrapper.didSendReduxAction(action);
    return next(action);
  };



// WEBPACK FOOTER //
// ./src/state/segment-middleware.js